// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
Vue.config.productionTip = false

/**
 * 导入ElementUI
 */
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// /**
//  * 导入过渡动画特效
//  */
// import '@/assets/animate.css';
// import '@/assets/css/animations.css';

// /**
//  * 导入动画工具类
//  */
// import { initAnimations } from '@/utils/animation';

// // 初始化动画效果
// Vue.prototype.$initAnimations = initAnimations;

/**
 * 导入axios
 */
import APIConfig from '@/components/config/APIConfig.js'
Vue.prototype.$post = APIConfig.post
Vue.prototype.$get = APIConfig.get
Vue.prototype.$del = APIConfig.del
Vue.prototype.$getBlob = APIConfig.getBlob
Vue.prototype.$uploadFile = APIConfig.uploadFile
Vue.prototype.$delJson = APIConfig.delJson
Vue.prototype.$postJson = APIConfig.postJson
Vue.prototype.$serverBaseUrl = "http://xiaozhaopin.cn:8080/xzyp/front/api"
// Vue.prototype.$serverBaseUrl = "http://127.0.0.1:8080/xzyp/front/api"
// Vue.prototype.$serverImg = "http://192.168.0.105:8080/eshop_api_v1/upload"


import StorageUtil from '@/components/config/StorageUtil.js'
Vue.prototype.$storageUtil = StorageUtil


// 引入高德地图
import VueAMap from 'vue-amap';
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key:'e57d2ce36c3740982aec5e4a8371967b',// 替换为你的高德地图API密钥
  plugin: ['AMap.Geolocation', 'AMap.Marker', 'AMap.InfoWindow'],
  v: '1.4.15'
});

// 全局性能优化
Vue.config.performance = process.env.NODE_ENV !== 'production';

// 图片懒加载指令
Vue.directive('lazy', {
  inserted: function(el, binding) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          el.src = binding.value;
          observer.unobserve(el);
        }
      });
    });
    observer.observe(el);
  }
});

// 防抖指令
Vue.directive('debounce', {
  bind: function(el, binding) {
    let timer;
    el.addEventListener('click', function() {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        binding.value();
      }, 300);
    });
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});






// WEBPACK FOOTER //
// ./src/main.js